export default __webpack_public_path__ + "static/stage-2_4-0050b11c8feb19c314126813cfe9f0bb.jpg";